<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<v-card :loading="loading" flat>
					<v-card-title>
						{{
							view
								? "Visualizar Area"
								: id
								? "Editar Area"
								: "Cadastrar Area"
						}}
					</v-card-title>
					<v-col class="pl-10 pr-10 pb-5" cols="12" md="12">
						<v-row>
							<v-col cols="12" md="4">
								<v-select
									v-model="chartlevel.CODGRP"
									:items="groups"
									item-text="DESGRP"
									item-value="CODGRP"
									label="Grupo"
									class="required"
									clearable
									:loading="loadingGroup"
									@change="getOrganizationChart(true);getChartsLevel()"
								></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select
									v-model="chartlevel.GERCOPARE"
									:items="corporateAreas"
									item-text="DESAREA"
									item-value="GERCOPARE"
									label="Área Corporativa"
									:loading="loadingCorporateArea"
									clearable
									@change="
										updateCorporateArea();
										getOrganizationChart(true);
										getChartsLevel();
									"
								></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select
									v-model="chartlevel.CODEMP"
									:items="companies"
									item-text="DESEMP"
									item-value="CODEMP"
									label="Empresa"
									:disabled="disableCompany"
									:loading="loadingCompany"
									clearable
									@change="getUnits(true)"
								></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select
									v-model="chartlevel.CODUNI"
									:items="units"
									item-text="DESUNI"
									item-value="CODUNI"
									label="Unidade"
									:disabled="disableUnit"
									:loading="loadingUnit"
									clearable
									@change="
										getAreas(true);
										getOrganizationChart(true);
										getChartsLevel();
									"
								></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select
									v-model="chartlevel.CODARE"
									:items="areas"
									item-text="DESARE"
									item-value="CODARE"
									label="Área"
									:disabled="disableArea"
									clearable
									:loading="loadingArea"
								></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select
									v-model="chartlevel.CODNVL"
									:items="linkedlevel"
									item-text="DESNVL"
									item-value="CODNVL"
									label="Nível"
									class="required"
									clearable
									:loading="loadingLinkedlevel"
								></v-select>
							</v-col>
							<v-col cols="12" md="12">
								<v-text-field
									v-model="chartlevel.DESOARE"
									label="Descrição"
									class="required"
								></v-text-field>
							</v-col>
						</v-row>
						<v-row class="mt-5">
							<v-container>
								<v-btn
									color="primary"
									depressed
									tile
									class="mr-4"
									@click="save"
									:disabled="loading"
									v-show="!view"
									>Salvar</v-btn
								>
								<v-btn
									color="primary"
									text
									class="mr-4"
									@click="
										$router.push(
											'/organization-chart/area/list'
										)
									"
									:disabled="loading"
									>Voltar</v-btn
								>
							</v-container>
						</v-row>
					</v-col>
				</v-card>
			</v-col>
		</v-row>
		<template>
			<Dialog ref="confirm" />
		</template>
	</v-container>
</template>

<script>
import CompanyGroupService from "../../app/Services/CompanyGroupService";

import Dialog from "../misc/Dialog";
import OrganizationChartService from "../../app/Services/OrganizationChartService";
import OrganizationChartLevelService from "../../app/Services/OrganizationChartLevelService";
import OrganizationChartLevelAreaService from "../../app/Services/OrganizationChartLevelAreaService";
import CompanyService from "../../app/Services/CompanyService";
import AreaService from "../../app/Services/AreaService";
import CorporateAreaService from "../../app/Services/CorporateAreaService";
import UnitService from "../../app/Services/UnitService";
import UserService from "../../app/Services/UserService";
import axios from "../../config/service/standard";

const companyGroupService = CompanyGroupService.build();
const organizationChartService = OrganizationChartService.build();
const organizationChartLevelAreaService = OrganizationChartLevelAreaService.build();
const companyService = CompanyService.build();
const areaService = AreaService.build();
const corporateAreaService = CorporateAreaService.build();
const unitService = UnitService.build();
const userService = UserService.build();

export default {
	name: "OrganizationChartLevelAreaForm",
	components: { Dialog },
	data: () => ({
		id: null,
		fileRules: [],
		view: false,
		groups: [],
		companies: [],
		areas: [],
		corporateAreas: [],
		units: [],
		organizationCharts: [],
		linkedlevel: [],
		status: [
			{ id: "A", description: "Aberto" },
			{ id: "F", description: "Fechado" },
		],
		chartlevel: {
			CODOARE: 0,
			CODGRP: 0,
			CODEMP: 0,
			CODUNI: 0,
			CODARE: 0,
			GERCOPARE: 0,
			DESOARE: "",
			CREATED_AT: "",
			UPDATED_AT: "",
		},
		loadingGroup: false,
		loading: false,
		loadingCompany: false,
		loadingUnit: false,
		loadingArea: false,
		loadingCorporateArea: false,
		loadingOrganizationChart: false,
		disableCompany: false,
		disableUnit: false,
		disableArea: false,
		loadingLinkedlevel: false,
		fileBase64: "",
	}),
	mounted() {
		const { id, view } = this.$route.params;

		if (id) {
			this.id = id;
		}

		if (view) {
			this.view = view;
		}

		this.fetch();
	},
	methods: {
		toast(type, message, icon = "mdi-check") {
			this.$toasted.show(message, {
				type: type,
				icon: icon,
			});
		},
		save() {
			if (!this.chartlevel.CODGRP) {
				this.toast("warning", "Informe o grupo para continuar");
				return;
			}

			if (!this.chartlevel.DESOARE) {
				this.toast("warning", "Informe o descrição para continuar");
				return;
			}

			if (!this.chartlevel.CODNVL) {
				this.toast("warning", "Informe o nível para continuar");
				return;
			}

			this.loading = true;
			this.chartlevel.CODGRP = this.chartlevel.CODGRP || 0;
			this.chartlevel.CODEMP = this.chartlevel.CODEMP || 0;
			this.chartlevel.CODUNI = this.chartlevel.CODUNI || 0;
			this.chartlevel.CODARE = this.chartlevel.CODARE || 0;
			this.chartlevel.GERCOPARE = this.chartlevel.GERCOPARE || 0;

			const rest = this.id
				? organizationChartLevelAreaService.update({
						id: this.id,
						...this.chartlevel,
				})
				: organizationChartLevelAreaService.create({
						...this.chartlevel,
				});

			rest.then((response) => {
				if (!response) {
					return;
				}

				this.toast(
					"success",
					this.id
						? "Area atualizada com sucesso!"
						: "Area adicionada com sucesso!"
				);
				this.loading = false;

				if (!this.isInModal) {
					this.$router.push("/organization-chart/area/list");
				} else {
					this.$emit("saved", true);
				}
			});
		},
		async getOrganizationChartLevel() {
			this.loading = true;

			return organizationChartLevelAreaService
				.read({ id: this.id })
				.then((response) => {
					this.chartlevel = response;
					this.loading = false;
				});
		},
		getGroup() {
			this.loadingGroup = true;

			companyGroupService.search("").then((response) => {
				this.groups = response;
				this.loadingGroup = false;
			});
		},
		getCompanies() {
			this.loadingCompany = true;
			return companyService.search({}).then((response) => {
				this.companies = response;
				this.loadingCompany = false;
			});
		},
		getUnits(change) {
			const search = {};

			this.units = [];
			this.areas = [];
			this.loadingUnit = true;

			if (change) {
				this.chartlevel.CODUNI = "";
				this.chartlevel.CODARE = "";
			}

			if (this.chartlevel.CODEMP) {
				search.company = this.chartlevel.CODEMP;
			}

			return unitService.search(search).then((response) => {
				this.units = response;
				this.loadingUnit = false;
			});
		},
		getAreas(change) {
			const search = {};

			this.areas = [];
			this.loadingArea = true;

			if (change) {
				this.chartlevel.CODARE = "";
			}

			if (this.chartlevel.CODEMP) {
				search.company = this.chartlevel.CODEMP;
			}

			if (this.chartlevel.CODUNI) {
				search.unit = this.chartlevel.CODUNI;
			}

			areaService.search(search).then((response) => {
				this.areas = response;
				this.loadingArea = false;
			});
		},
		getCorporateArea(change) {
			const search = {};

			this.corporateAreas = [];
			this.loadingCorporateArea = true;

			if (change) {
				this.chartlevel.CODARE = "";
			}

			if (this.chartlevel.CODEMP) {
				search.company = this.chartlevel.CODEMP;
			}

			if (this.chartlevel.CODUNI) {
				search.unit = this.chartlevel.CODUNI;
			}

			corporateAreaService.search(search).then((response) => {
				this.corporateAreas = response;
				this.loadingCorporateArea = false;
			});
		},
		getOrganizationChart(change) {
			const search = {};

			this.organizationCharts = [];
			this.loadingOrganizationChart = true;

			if (this.chartlevel.GERCOPARE) {
				search.corporateArea = this.chartlevel.GERCOPARE;
			} else {
				if (change) {
					this.chartlevel.CODOARE = "";
				}

				if (this.chartlevel.CODGRP) {
					search.company = this.chartlevel.CODGRP;
				}

				if (this.chartlevel.CODEMP) {
					search.company = this.chartlevel.CODEMP;
				}

				if (this.chartlevel.CODUNI) {
					search.unit = this.chartlevel.CODUNI;
				}
			}

			if (search) {
				organizationChartService.search(search).then((response) => {
					this.organizationCharts = response.data;
					this.loadingOrganizationChart = false;
				});
			}
		},
		async getChartsLevel() {
			const search = {};

			this.organizationCharts = [];
			this.loadingLinkedlevel = true;

			if (this.chartlevel.GERCOPARE) {
				search.corporateArea = this.chartlevel.GERCOPARE;
			} else {
				if (this.chartlevel.CODGRP) {
					search.company = this.chartlevel.CODGRP;
				}

				if (this.chartlevel.CODEMP) {
					search.company = this.chartlevel.CODEMP;
				}

				if (this.chartlevel.CODUNI) {
					search.unit = this.chartlevel.CODUNI;
				}
			}

			if (search) {
				const query = {
					params: {
						filter: search
					}
				};
				const response =
					await OrganizationChartLevelService.build().index({
						query,
					});

        this.linkedlevel = response.data;
				this.loadingLinkedlevel = false;
			}
		},
		getUsers() {
			this.loadingUser = true;
			return userService.usersByKey().then((response) => {
				this.users = response;
				this.loadingUser = false;
			});
		},
		updateCorporateArea() {
			if (parseInt(this.chartlevel.GERCOPARE) > 0) {
				this.chartlevel.CODEMP = 0;
				this.chartlevel.CODUNI = 0;
				this.chartlevel.CODARE = 0;

				this.disableCompany = true;
				this.disableUnit = true;
				this.disableArea = true;
			} else {
				this.disableCompany = false;
				this.disableUnit = false;
				this.disableArea = false;
			}
		},
		fetch() {
			const funcs = [];

			if (this.id) {
				funcs.push(this.getOrganizationChartLevel());
			}

			funcs.push(this.getGroup());
			funcs.push(this.getCompanies());
			funcs.push(this.getUsers());
			funcs.push(this.getCorporateArea());
			funcs.push(this.getOrganizationChart());
			funcs.push(this.getChartsLevel());

			Promise.all(funcs)
				.then(() => {
					if (this.id) {
						this.getUnits(false);
						this.getAreas();
						this.updateCorporateArea();
						this.getOrganizationChart();
						this.getChartsLevel();
					}
				})
				.finally(() => {});
		},
		onFileSelect(fileTmp) {
			if (fileTmp == null) return;

			this.chartlevel.FILE_NAME = fileTmp.name;

			this.toBase64(fileTmp).then((base64) => {
				this.fileBase64 = base64;
			});
		},
		toBase64(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = () => resolve(reader.result);
				reader.onerror = (error) => reject(error);
				reader.readAsDataURL(file);
			});
		},
		download() {
			this.$root.$Loading.show("Fazendo download...");

			axios
				.get("/api/process/download", {
					responseType: "arraybuffer",
					params: {
						id: this.chartlevel.GERPRO,
					},
				})
				.then((response) => {
					let blob = new Blob([response.data], {
						type: "application/pdf",
					});
					let link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download = this.chartlevel.TITPRO;
					link.click();
				})
				.finally(() => {
					this.$root.$Loading.hide();
				});
		},
		async removeDownload() {
			await this.$refs.confirm
				.open("Atenção", "Deseja mesmo excluir?")
				.then(() => {
					this.$root.$Loading.show("Removendo arquivo...");

					axios
						.post("/api/process/removeDownload", {
							id: this.chartlevel.GERPRO,
						})
						.then(() => {
							this.toast(
								"success",
								"Arquivo removido com sucesso!"
							);
							this.chartlevel.FILE = null;
						})
						.finally(() => {
							this.$root.$Loading.hide();
						});
				});
		},
	},
};
</script>
